import React, { useContext } from "react";
import { IndexView, ShowView } from "lego-gui-lib";
import { webUserAccessContext, WebUserAccessSchema } from "./schema";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router";

export const WebUserAccessIndex = observer((rest: any) => {
  const i18n = useTranslation();
  const title = i18n.t("hns:webUserAccess:nestedTitle");
  const webUserAccessWithContext = useContext(webUserAccessContext);

  return (
    <>
      <IndexView
        {...rest}
        dataSource={webUserAccessWithContext.listDataSource}
        title={title}
        baseUrl="/webAccess"
        columns={WebUserAccessSchema}
        toolbarButtons={{ delete: false, export: false }}
        rowButtons={{ edit: true, delete: false, copy: false }}
        titleButtons={() => <></>}
      />
    </>
  );
});

export const WebUserAccessShow = observer((rest: any) => {
  const i18n = useTranslation();
  const title = i18n.t("common:edit", {
    domain: "hns:webUserAccess:nestedTitle"
  });
  const match = useRouteMatch();
  const webUserAccessWithContext = useContext(webUserAccessContext);
  const baseUrl = match.url;
  const parentTitle = i18n.t("common:edit", { domain: "hns:webUser:domain" });
  const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
  const history = useHistory();
  const id = {
    // @ts-ignore
    id: match.params.webAccessId
  };

  return (
    <>
      <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
      <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
      <ShowView
        dataSource={webUserAccessWithContext.oneDataSource}
        title={title}
        goBack={() => history.goBack()}
        {...rest}
        fields={WebUserAccessSchema}
        hideDeleteButton={true}
        id={id}
      />
    </>
  );
});
